
import { form13StatusInfoType } from '@/types/Information/Form13';
import { Component, Prop, Vue } from 'vue-property-decorator';

import StepNumber from "@/components/utils/StepNumber.vue";

@Component({
    components:{
        StepNumber
    }
})
export default class Form13ProcessHeader extends Vue {  
    
    @Prop({required: true})
    stepsCompleted!: form13StatusInfoType;

}
